var _polygon, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMixer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "15.4,8.8 15.4,14.4 1,14.4 1,7.2 1.6,7.2 3.6,13.6 12.9,13.6 14.7,8.9 14.3,8.6 14.3,8.2 15.4,8.2  "
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.9,9.4 12.3,13.1 9.7,13.1 5.1,11.6 3,9.2 4.6,5 7.4,5 11.8,6.7 13.9,8.6  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "4.3,5 2.8,8.8 2.1,6.9 2.6,5.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.4,8.6c0,1,0,1.9,0,2.9c0.9,0,1.8,0,2.7,0c-0.3-1-0.6-1.9-0.8-2.8C18.7,8.6,18,8.6,17.4,8.6z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2,16.2c-0.3,0-0.6,0.2-0.6,0.5c0,0,0,0.1,0,0.1c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.4,0.2 s0.3,0,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0,0,0-0.1,0-0.1C18.7,16.4,18.5,16.2,18.2,16.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1,16.4c-0.1-0.2-0.3-0.3-0.5-0.3S3.2,16.3,3,16.4c0,0.1-0.1,0.2-0.1,0.3c0,0,0,0.1,0,0.1 c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.4,0.2s0.3,0,0.4-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0,0,0-0.1,0-0.1 C4.2,16.6,4.2,16.5,4.1,16.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8,14.4c0,0.4,0,0.7,0,1c0.6,0,1.1,0,1.7,0c0-0.3,0-0.7,0-1C21.9,14.4,21.4,14.4,20.8,14.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.2,14.7c-1.2,0-2.2,1-2.2,2.2c0,1.2,1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2C20.3,15.6,19.3,14.7,18.2,14.7z  M18.6,17.3c-0.1,0.1-0.3,0.2-0.4,0.2s-0.3,0-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0,0,0-0.1,0-0.1c0-0.3,0.3-0.5,0.6-0.5 c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0.1,0,0.1C18.8,17,18.7,17.1,18.6,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3.6,14.7L3.6,14.7c-1.1,0-1.9,0.7-2.1,1.8c0,0.1,0,0.2,0,0.4c0,1.2,1,2.2,2.2,2.2s2.2-1,2.2-2.2 c0-0.1,0-0.3,0-0.4C5.5,15.4,4.7,14.7,3.6,14.7z M4,17.3c-0.1,0.1-0.3,0.2-0.4,0.2s-0.3,0-0.4-0.2S2.9,17,2.9,16.8 c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.3c0.1-0.2,0.3-0.3,0.5-0.3s0.4,0.1,0.5,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0.1,0,0.1 C4.2,17,4.1,17.1,4,17.3z"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8,14.7H1v1.8h0.4c0,0,0,0,0,0C1.5,15.6,2.1,14.9,2.8,14.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,15.3c0-1,0-1.9,0-2.9c-0.3-0.1-0.6-0.3-0.9-0.4c-0.2-0.1-0.4-0.2-0.7-0.3c0,0,0,0-0.1,0 c-0.4-0.2-0.4-0.8-0.6-1.3c-0.2-0.7-0.5-1.4-0.7-2.2c-0.1-0.4-0.2-0.9-0.1-1.4c-1.3,0-2.6,0-3.8,0l0,0l0,0l0,0v1.6l0,0 c0,2.1,0,4.2,0,6.3H4.4c0.7,0.3,1.3,0.9,1.5,1.8c0,0,0,0,0,0h9.9c0.3-1,1.1-1.9,2.2-2c1.2-0.2,2.4,0.8,2.6,1.9 c0.8,0,1.6,0,2.5,0c0-0.4,0-0.7,0-1C22.9,15.3,22.7,15.3,22.6,15.3z M17.4,11.4c0-1,0-1.9,0-2.9c0.6,0,1.3,0,1.9,0 c0.3,0.9,0.6,1.9,0.8,2.8C19.2,11.5,18.3,11.4,17.4,11.4z M22.5,15.4c-0.6,0-1.1,0-1.7,0c0-0.4,0-0.7,0-1c0.6,0,1.1,0,1.7,0 C22.5,14.8,22.5,15.1,22.5,15.4z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixer);
export default __webpack_public_path__ + "static/media/mixer.fa85b208a6df14e564778cd10e4cbcdb.svg";
export { ForwardRef as ReactComponent };